import { render, staticRenderFns } from "./SidePanel2.vue?vue&type=template&id=6246d5f0&scoped=true&"
import script from "./SidePanel2.vue?vue&type=script&lang=ts&"
export * from "./SidePanel2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6246d5f0",
  null
  
)

export default component.exports